/**
 * The saved-block hover preview loads the production email HTML into a
 * desktop-width iframe, so "hide on desktop" content is hidden twice:
 * by the renderer's head CSS (media query / base rule depending on
 * desktopFirst) and by inline display:none injected for Outlook web.
 * Appending this style at the END of <body> beats both — last-in-cascade
 * !important wins over the head rules, and any !important beats the
 * non-important inline styles. `display: revert` restores each element's
 * UA default (table, table-cell, block, ...), covering both the block
 * (<td>) and section (<table>/<div>) variants with one rule.
 * The 25% opacity matches how the editor canvas renders content hidden on
 * the current device (useBlockProperties/mjmlSection hiddenStyle), so the
 * preview shows what the block contains without pretending it renders
 * normally on desktop.
 */
const REVEAL_STYLE = `<style>.hide_on_desktop, .hide_section_on_desktop { display: revert !important; max-height: none !important; overflow: visible !important; opacity: 0.25 !important; }</style>`;

export function revealHiddenOnDevicePreview(html: string): string {
  if (!html) {
    return html;
  }
  if (html.includes("</body>")) {
    return html.replace("</body>", `${REVEAL_STYLE}</body>`);
  }
  return html + REVEAL_STYLE;
}
